"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var newsletterImage = {
  altText: "Newsletter image",
  originalSrc: "/static/images/dialog/newsletter_dialog.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/newsletter_top.jpg",
      w: 465,
      h: 350
    }]
  }]
};
var _default = newsletterImage;
exports["default"] = _default;